import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, Col, Row } from 'react-bootstrap';
import { Button, Container } from 'reactstrap';
import { Breadcrumbs, IconButton, Typography } from "@mui/material";
import toastAlert from '../../../js/Base/ToastAlert';
import PaginationTableWithFuncBtn from '../../../components/Util/PaginationTableWithFuncBtn';
import ProjectRoleEditModal from './ProjectRoleEditModal';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import { getProjectRoles, changeProjectRoleStatus } from '../../../api/projectApi';

export default function ProjectRoleManagement() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCreateRole, setIsCreateRole] = useState(true);
  const [selectedProjectRole, setSelectedProjectRole] = useState(null);
  const [projectRoles, setProjectRoles] = useState([]);
  const { email, isAdmin } = useSelector(state => state.user);
  const projectUuid = localStorage.getItem("project_uuid");

  const fetchProjectRoles = async () => {
    if (!projectUuid) return;

    try {
      const res = await getProjectRoles({
        project_uuid: projectUuid
      });
      const data = res.data;

      if (data.success) {
        setProjectRoles(data.roles);
      } else {
        toastAlert.autoClose(true).showError("取得專案角色失敗，請稍後再試");
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("取得專案角色失敗，請稍後再試");
    }
  };

  useEffect(() => {
    fetchProjectRoles();
  }, []);

  const col_name = ["角色", "說明", "狀態", "功能項", "動作"];
  const data_frame = [
    { keyName: 'name', isBadge: false },
    { keyName: 'desc', isBadge: false },
    { keyName: 'status', isBadge: false },
    { keyName: 'status', isSlide: true },
    { keyName: 'func', isClick: true, editBtn: true },
  ];
  const col_size = ['22%', '42%', '8%', '14%', '14%'];
  const newProjectRoles = projectRoles
  .filter(role => {
    return isAdmin ? true : role.name !== "eDC Admin";
  })
  .map((data) => ({
    ...data,
    status: data.is_cancel ? "停用" : "啟用",
  }));

  const statusOnChange = (uuid) => {
    changeProjectRoleStatusByWebApi(uuid);
  };

  const handleEdit = (uuid) => {
    toggleModal(uuid);
  };

  const toggleModal = (roleUuid = null) => {
    const role = projectRoles.find((role) => role.uuid === roleUuid) || null;
    setSelectedProjectRole(role);
    setIsCreateRole(roleUuid === null ? true : false);
    setIsModalOpen(!isModalOpen)
  };

  const changeProjectRoleStatusByWebApi = async (roleUuid) => {
    try {
      const res = await changeProjectRoleStatus(roleUuid);
      const data = res.data;

      if (data.success) {
        toastAlert.autoClose(true).showSuccess(
          data.role.is_cancel ? "停用成功" : "啟用成功"
        );
        // 重新取得專案角色
        const rolesRes = await getProjectRoles({
          project_uuid: projectUuid
        });
        if (rolesRes.data.success) {
          setProjectRoles(rolesRes.data.roles);
        }
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("發生錯誤，請稍後再試");
    }
  };


  return (
    <React.Fragment>
      <Container className="mt-2">
        <div style={{ marginRight: '20px' }}>
          <Breadcrumbs
            className="link-area"
            style={{ padding: "0 0 20px 0", fontWeight: 'bold'}}
            separator={<NavigateNextIcon style={{ fontSize: '20px', fontWeight: 'bold' }} />}
            aria-label="breadcrumb"
          >
            <Link to="/admin-management" style={{ color: '#1d1d1d', fontSize: '20px', textDecoration: 'none', fontWeight: 'bold' }}>
              <p style={{ marginBottom: '0px' }}>人員管理</p>
            </Link>
            <Link to="/project/project-role-management" style={{ color: '#1d1d1d', fontSize: '20px', textDecoration: 'none', fontWeight: 'bold' }}>
              <p style={{ marginBottom: '0px' }}>角色定義</p>
            </Link>
          </Breadcrumbs>

          <div>
            <Card>
              <Card.Header style={{ backgroundColor: 'transparent' }}>
                <strong>人員角色</strong>
                {projectRoles.length > 0 && (
                  <IconButton
                    onClick={() => toggleModal(null)}
                      sx={{
                        color: "black",
                        width: 32,
                        height: 32,
                      }}
                    >
                      <Typography variant="h6" component="span" sx={{ lineHeight: 1 }}>
                        <AddIcon fontSize="medium" />
                      </Typography>
                  </IconButton>
                )}

              </Card.Header>
              <Card.Body style={{ paddingTop: "5px" }}>
                <Row className="mb-3 mt-3">
                  {newProjectRoles.length > 0 ? (
                    <PaginationTableWithFuncBtn
                      rowData={newProjectRoles}
                      colName={col_name}
                      dataFrame={data_frame}
                      col_size={col_size}
                      editModalOpen={handleEdit}
                      switchOnChange={statusOnChange}
                    />
                  ) : (
                    <Col md={12} className="d-flex justify-content-end align-items-center mb-2">
                      <Button
                        style={{ width: '90px', height: '34px', fontSize: '14px', fontWeight: 'bold' }}
                        outline
                        onClick={() => toggleModal(null)}
                      >
                        新增
                      </Button>
                    </Col>
                  )}
                </Row>
              </Card.Body>
            </Card>

            <ProjectRoleEditModal
              isModalOpen={isModalOpen}
              isCreate={isCreateRole}
              role={selectedProjectRole}
              toggleModal={() => toggleModal(null)}
              submitEffect={fetchProjectRoles}
            />
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
}
